namespace GeniuzPOS.Product {
    export class CsBrandColumns {
        static columnsKey = 'Product.CsBrand';
    }
}
